import { useTranslation } from 'react-i18next'

/** Столько упаковок и меньше — «осталось N шт.», чтобы не ехать зря. */
export const FEW = 3

/** Сколько товара в аптеке: «в наличии» или «осталось N шт.». */
export function StockPill({ qty }: { qty: number }) {
  const { t } = useTranslation('catalog')
  return (
    <span className={qty <= FEW ? 'pill few' : 'pill st'}>
      {qty <= FEW ? t('catalog:product.left', { count: qty }) : t('catalog:product.inStock')}
    </span>
  )
}
